import type { VoiceMessage } from '../api/types';
import type { AudioPlayerState } from '../hooks/useAudioPlayer';
import { VoiceItem } from './VoiceItem';
import './VoiceList.css';

interface Props {
  voices: VoiceMessage[];
  playerState: AudioPlayerState;
  onVoiceToggle: (voice: VoiceMessage) => void;
  hiddenCount: number;
  access: 'guest_preview' | 'member_locked' | 'owner' | 'partial' | 'subscribed';
  onShowGate: () => void;
}

export function VoiceList({
  voices,
  playerState,
  onVoiceToggle,
  hiddenCount,
  access,
  onShowGate,
}: Props) {
  return (
    <section className="voice-list">
      <div className="voice-list-head">
        <h2>Messages</h2>
        <span>{voices.length} available</span>
      </div>

      <div className="voice-list-items">
        {voices.map((voice) => (
          <VoiceItem
            key={voice.id}
            voice={voice}
            isActive={playerState.activeVoiceId === voice.id}
            isPlaying={playerState.activeVoiceId === voice.id && playerState.isPlaying}
            onToggle={() => onVoiceToggle(voice)}
          />
        ))}
      </div>

      {(access === 'guest_preview' || access === 'member_locked' || access === 'partial') && hiddenCount > 0 ? (
        <div className="voice-list-locked-card">
          <strong>{hiddenCount} more subscriber-only messages</strong>
          <p>Login and subscribe in SecretTalk to unlock the full channel archive.</p>
          <button type="button" onClick={onShowGate}>
            View access options
          </button>
        </div>
      ) : null}
    </section>
  );
}
